import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';

const spin = {
  animate: { rotate: 360 },
  transition: { repeat: Infinity, ease: 'linear' },
};

const DrillVocabLoadingOverlay = ({
  visible = false,
  text = 'Submitting your answers...',
  subtext,
}) => {
  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="fixed inset-0 flex justify-center items-center z-[9999] bg-[#345d8a] dark:bg-[linear-gradient(135deg,#1e3d6f_0%,#2a4f8a_50%,#152d55_100%)]"
          role="status"
          aria-live="polite"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.25, ease: 'easeOut' }}
        >
          <div className="flex flex-col items-center gap-7">
            <div className="relative w-20 h-20 max-md:w-16 max-md:h-16">
              <motion.div
                className="absolute rounded-full border-[3px] border-transparent border-t-[#feca57] w-20 h-20 max-md:w-16 max-md:h-16"
                animate={spin.animate}
                transition={{ ...spin.transition, duration: 1.5 }}
                aria-hidden
              />
              <motion.div
                className="absolute rounded-full border-[3px] border-transparent border-r-[#f9a825] w-[60px] h-[60px] top-2.5 left-2.5 max-md:w-12 max-md:h-12 max-md:top-2 max-md:left-2"
                animate={{ rotate: -360 }}
                transition={{ repeat: Infinity, ease: 'linear', duration: 1.2 }}
                aria-hidden
              />
              <motion.div
                className="absolute rounded-full border-[3px] border-transparent border-b-[#ffe082] w-10 h-10 top-5 left-5 max-md:w-8 max-md:h-8 max-md:top-4 max-md:left-4"
                animate={spin.animate}
                transition={{ ...spin.transition, duration: 0.9 }}
                aria-hidden
              />
              <motion.div
                className="absolute w-4 h-4 top-8 left-8 rounded-full bg-gradient-to-br from-[#feca57] to-[#f9a825] max-md:w-3 max-md:h-3 max-md:top-[26px] max-md:left-[26px]"
                animate={{ scale: [1, 1.2, 1] }}
                transition={{ repeat: Infinity, duration: 1, ease: 'easeInOut' }}
                aria-hidden
              />
            </div>
            <p className="m-0 text-lg font-semibold text-white text-center leading-snug max-md:text-base">
              {text}
            </p>
            {subtext && (
              <p className="-mt-3 text-sm font-normal text-white/70 text-center leading-snug max-md:text-[13px]">
                {subtext}
              </p>
            )}
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default DrillVocabLoadingOverlay;
